import { ArrowRight, Eye, Target, Users } from "lucide-react";
import PageHeader from "./pageHeader";
import { Link } from "react-router-dom";
import { CoreValuesImageSection } from "./ui/corevaluesImageSection";

const AboutUs = () => {
  const values = [
    { icon: <Target className="w-8 h-8" />, title: "Our Mission", description: "Putting people first, building relationships, fostering connections, and creating spaces that truly make a difference in people's lives." },
    { icon: <Eye className="w-8 h-8" />, title: "Our Vision", description: "To make a profound impact that will reverberate beyond the boundaries of our tri-city community, transforming lives and leaving a positive legacy." },
    { icon: <Users className="w-8 h-8" />, title: "Our Values", description: "Trust, Credibility, Delivery, Transparency, Passion, Perfection, Ethical practices, and dedication to results." },
  ];
  const timeline = [
    { year: "1996", title: "The Foundation", description: "Mr. Ranjit Singh Gill's entrepreneurial journey laid the foundation for a transformational force in real estate." },
    { year: "2001", title: "Gillco Developers Born", description: "The dream took form as Gillco Developers. Families placed their trust and Gillco became a movement." },
    { year: "2004", title: "Gillco Valley", description: "Gillco made history developing one of the largest townships in Kharar-Mohali." },
    { year: "2005", title: "Gillco Group of Companies", description: "Gillco evolved into the Gillco Group of Companies, expanding horizons." },
    { year: "2013", title: "Gillco Parkhills & School", description: "Premium residential development and Gillco International School, nurturing future generations." },
    { year: "2017", title: "Industrial Park", description: "Gillco Industrial Park on IT City Road fueled economic growth across Punjab." },
  ];
  return (
    <div data-testid="v13-about-page">
      <PageHeader title="About Gillco" subtitle="Our Legacy" backgroundImage="/assets/about/about-img.jpg" />
      <section className="bg-white pt-24 lg:pt-32 pb-4 lg:pb-6">
        <div className="max-w-6xl mx-auto px-6 lg:px-12">
          <div className="flex gap-8 lg:gap-16">
            {/* Vertical rotated label + gold line */}
            <div className="hidden md:flex flex-col items-center">
              <span
                className="text-[11px] tracking-[0.3em] uppercase text-[#C4A265]"
                style={{ writingMode: "vertical-lr", letterSpacing: "0.3em" }}
              >
                GILLCO GROUP
              </span>
              <div className="w-[1px] bg-[#C4A265] flex-1 mt-4 min-h-[120px]" />
            </div>

            {/* Heading + Body + 25+ Years stat */}
            <div className="flex-1">
              <h2
                className="text-4xl sm:text-5xl lg:text-6xl text-[#0A0A0A] mb-12 lg:mb-14 leading-[1.05] relative inline-block pr-6"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                We Build Dreams
                {/* Gold dot accent */}
                <span className="absolute bottom-3 -right-2 w-2 h-2 rounded-full bg-[#C4A265]" />
              </h2>

              <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                {/* Paragraphs */}
                <div className="lg:col-span-8">
                  <p className="text-[#4A4A4A] leading-relaxed mb-6" style={{ textAlign: "justify" }}>
                    Gillco Group is a name synonymous with a legacy of trust, disciplined growth, and enduring value creation, firmly anchored in the ethos of Punjab. Established in 2001 by Mr Ranjit Singh Gill and Mrs Paramjit Gill, the Group was founded on a clear strategic vision: to unlock land potential and develop integrated communities that address the evolving aspirations of modern India. What began as a focused initiative has since evolved into a diversified real estate enterprise, built on the principles of reliability, quality and long-term stakeholder value.
                  </p>
                  <p className="text-[#4A4A4A] leading-relaxed" style={{ textAlign: "justify" }}>
                    Under the present leadership, Gillco has accelerated its trajectory, expanding across residential and commercial segments while consistently enhancing execution standards. The Group's developments reflect a calibrated approach that balances design, functionality and investment viability. Today, Gillco's sustained growth is underpinned by the trust of its customers and partners, bolstering its position as a leader in North India's real estate landscape.
                  </p>
                </div>

                {/* 25+ Years stat — elegant editorial display */}
                <div className="lg:col-span-4 lg:pl-8 lg:border-l lg:border-[#C4A265]/30">
                  <div className="flex items-baseline gap-2">
                    <span
                      className="text-7xl lg:text-8xl text-[#0A0A0A] font-light leading-none"
                      style={{ fontFamily: "'Cormorant Garamond', serif" }}
                    >
                      25
                    </span>
                    <span
                      className="text-4xl lg:text-5xl text-[#C4A265] font-light leading-none"
                      style={{ fontFamily: "'Cormorant Garamond', serif" }}
                    >
                      +
                    </span>
                  </div>
                  <div className="w-12 h-[2px] bg-[#C4A265] mt-5 mb-4" />
                  <div className="text-[11px] uppercase tracking-[0.3em] text-[#4A4A4A] mb-6">Years of Excellence</div>
                  <p
                    className="text-sm text-[#6a6a6a] italic leading-relaxed"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    A quarter-century of building communities, shaping skylines, and earning the trust of generations across North India.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values - Full screen image with scroll expand animation */}
      <CoreValuesImageSection />

    </div>
  );
};
export default AboutUs;